import React from 'react';

interface FormattedDateProps {
  date: string | null | undefined;
  className?: string;
}

const dateTimeFormatter = new Intl.DateTimeFormat(undefined, {
  year: 'numeric',
  month: 'short',
  day: 'numeric',
  hour: 'numeric',
  minute: '2-digit',
});

const FormattedDate: React.FC<FormattedDateProps> = ({ date, className = '' }) => {
  if (!date) return <span className={className}>-</span>;

  const parsedDate = new Date(date);
  if (Number.isNaN(parsedDate.getTime())) {
    return <span className={className}>-</span>;
  }

  return <span className={className}>{dateTimeFormatter.format(parsedDate)}</span>;
};

export default FormattedDate;
